import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  Image,
  ImageContainer,
  Title,
  Price,
} from "./ProductCard.styles";
import { useSelector } from "react-redux";
import { getSupplierData } from "../../Redux/Selectors/appConfigSelector";

const ProductCard = ({ image, title, price, ...restProps }) => {
  const supplierData = useSelector(getSupplierData);
  return (
    <Card {...restProps}>
      <ImageContainer>
        <Image src={image} alt={`Alquilar ${title} - ${supplierData.name}`} />
      </ImageContainer>
      <Title ellipsis={true}>{title}</Title>
      <Price strong>{price}</Price>
    </Card>
  );
};

ProductCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
};

export default ProductCard;
